import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {GgwDeviceParam} from "@catmodels/ggw-device-params/types";
import {NotificationsService} from "@catcore/services";
import {FeatureGgwDeviceParamService} from "@catmodels/ggw-device-params/services/feature-ggw-device-param.service";
import {Observable} from "rxjs";
import {Parameter} from "@catmodels/parameters/types";
import {extractDataFromModel} from "@catcore/utils";
import {ConfirmationService} from "primeng/primeng";
import {ProjectGgwDeviceParamService} from "@catmodels/ggw-device-params/services/project-ggw-device-param.service";

@Component({
  selector: 'cat-create-ggw-dev-params-from-xml',
  templateUrl: './create-ggw-dev-params-from-xml.component.html',
  styleUrls: ['./create-ggw-dev-params-from-xml.component.scss']
})
export class CreateGgwDevParamsFromXmlComponent implements OnInit {

  @Input()
  visible: boolean = false;

  @Input()
  ggwDevice: any;

  @Input()
  featureLevel: boolean;

  @Output() onCancel = new EventEmitter();
  @Output() afterCreate = new EventEmitter<GgwDeviceParam[]>();

  @ViewChild('textarea')
  textareaElem: ElementRef;

  constructor(private notificationService: NotificationsService,
              private confirmationService: ConfirmationService,
              private featureGgwDevParamService: FeatureGgwDeviceParamService,
              private projectGgwDevParamService: ProjectGgwDeviceParamService) { }

  ngOnInit() {
  }

  cancel() {
    this.onCancel.emit();
  }

  /**
   * Creates ggw device params from the given xml string.
   *
   * @param textareaValue
   */
  create(textareaValue) {
    let parsedXml;

    const params = [];
    const existingKeys = [];
    try {
      parsedXml = this.parseXml('<root>' + textareaValue + '</root>');
      console.log(parsedXml);

      let configElems = Array.from(parsedXml.getElementsByTagName('config'));
      configElems.forEach((param: any) => {
        let key = param.getAttribute('key');
        let value = param.getAttribute('value');
        if (key === null || key === '') {
          throw new Error('Parameter key must not be empty.');
        }
        if (this.parameterKeyExists(key)) {
          existingKeys.push(key);
        }
        if (value === null) {
          value = '';
        }
        params.push({
          "ggw_device": this.ggwDevice._links.self.href,
          "key": key,
          "value": value
        });
      });

    } catch(e) {
      this.notificationService.error('Invalid XML', e.message);
    }

    if (existingKeys.length > 0) {
      const msg = 'The following ' + existingKeys.length + ' parameter key(s) already exist and will be ignored: ' + existingKeys.join(', ');
      this.confirmationService.confirm({
        message: msg,
        accept: () => this.createParams(params)
      });
    } else {
      this.createParams(params);
    }
  }

  /**
   * Creates the given ggw device params by submitting a request for each param.
   *
   * @param params
   */
  createParams(params) {
    const requests = [];
    params.forEach((param) => {
      if (param !== null) {
        if (this.featureLevel) {
          requests.push(this.featureGgwDevParamService.create(param));
        } else {
          requests.push(this.projectGgwDevParamService.create(param));
        }
      }
    });

    Observable.forkJoin(requests)
      .subscribe((multiple: GgwDeviceParam[]) => {
        const newKeys = multiple.map((param) => param.key).join(', ');
        this.notificationService.success('Creation successful', 'Successfully created ' + multiple.length + ' parameters: ' + newKeys);
        this.textareaElem.nativeElement.value = '';
        this.afterCreate.emit(multiple as Parameter[]);
      })
    ;
  }

  /**
   * Parses the given xml string. Not compatible with IE.
   *
   * @param xmlString
   */
  parseXml(xmlString) {
    let parser = new DOMParser();
    // attempt to parse the passed-in xml
    let dom = parser.parseFromString(xmlString, 'text/xml');
    this.checkParseError(dom);
    return dom;
  }

  /**
   * Checks the given dom document for parse errors. Unfortunately, the only way
   * to identify parse errors is to look for the tag 'parsererror'.
   *
   * @param parsedDocument
   */
  private checkParseError(parsedDocument) {
    let parsererrorElements = parsedDocument.getElementsByTagName("parsererror");
    if (parsererrorElements.length > 0) {
      throw new Error(parsererrorElements[0].innerHTML);
    }
  };

  /**
   * Checks if a parameter key already existis on the ggw device.
   * TODO: Remove workaround that only checks the label of the parameter
   *
   * @param key
   */
  private parameterKeyExists(key) {
    const params = extractDataFromModel(this.ggwDevice, 'parameters');
    const existingKey = params.find((param) => {
      return param.label.indexOf(key + ' -> ') === 0;
    });
    return existingKey !== undefined;
  }

}


// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/ggw-device-params/components/create-ggw-dev-params-from-xml/create-ggw-dev-params-from-xml.component.ts